import React, { Component, Fragment } from 'react';
import done_black from '../images/done-black.svg';
import '../styles/Purchase.scss';
import Footer from './Footer';
import SideBar from './SideBar';
import Header from './Header';
import loader from '../images/loader.gif';
import '../styles/CommonStyle.scss';
import { withTranslation } from 'react-i18next';
import { getAddOns } from '../services/add-on-service';
import { getAllLanguage } from '../services/language-service';
import { getTokenDetailsByDecoding } from '../services/cookie-storage-service';
import { getTenantLanguages, getTenantProduct, getTenantPackage } from '../services/tenant-identity-service';
import { getLocation } from '../services/branch-service';

class Purchases extends Component {
    constructor(props) {
        super(props);
        let tenantGuid = getTokenDetailsByDecoding().tenantGuid;
        this.state = {
            tenantGuid: tenantGuid,
            tenantLanguageList: [],
            languageList: [],
            locationList: [],
            productList: [],
            addOnList: [],
            tenantPackageList: [],
            tenantProductAndLicenseDetailsList: []
        }
    }

    componentDidMount = async () => {
        await this.getAddOnList();
        await this.getAllLanguages();
        await this.getTenantLanguage();
        await this.getProduct();
        await this.getPackage();
        await this.getLocation();
    }

    //Get all available languages from language service.
    getAllLanguages = async () => {
        try {
            let response = await getAllLanguage();
            var langFromApi = response.reduce(function (filtered, value) {
                // if (value.Code != 'en') {
                var newObj = { value: value.LanguageId, display: value.Name }
                filtered.push(newObj);
                // }
                return filtered;
            }, []);

            this.setState({ languageList: langFromApi });
        } catch (err) {
            console.log('getAllLanguages error', err.response);
        }
    }

    getTenantLanguage = async () => {
        let selectedLanguages = [];
        const { languageList, tenantGuid } = this.state;

        let response = await getTenantLanguages(tenantGuid);

        if (response.length > 0) {
            let selectedLangArr = response[0].languageGuid;

            languageList.forEach((lang) => selectedLangArr.forEach((obj) => {
                if (lang['value'].toLowerCase() === obj.toLowerCase()) {
                    selectedLanguages.push({ value: lang.value, display: lang.display });
                }
            })
            );

            this.setState({ tenantLanguageList: selectedLanguages });
        }
    }

    getProduct = async () => {
        try {
            let response = await getTenantProduct();
            let result = response.map(value => {
                return { value: value.ProductGuid, display: value.ProductName }
            });

            this.setState({ productList: result });
        } catch (error) {
            console.log('getProduct error', error);
        }
    }

    getPackage = async () => {
        try {
            const { tenantGuid, productList } = this.state;

            getTenantPackage(tenantGuid)
                .then(async (response) => {
                    if (response.length > 0) {
                        let tenantPackageList = response;

                        //Aggregate product with package
                        tenantPackageList = await this.aggregateProductWithPackage(tenantPackageList, productList);
                        this.setState({ tenantPackageList: tenantPackageList });

                        //Calculate total license count aginst each product.
                        let productAndLicenseDetailsList = await this.calculateLicenseCountPerProduct(tenantPackageList);

                        this.setState({ tenantProductAndLicenseDetailsList: productAndLicenseDetailsList });
                    }
                })
                .catch((err) => {
                    console.log('getPackage api error', err);
                });

        } catch (error) {
            console.log('getPackage error', error);
        }
    }

    getAddOnList = async () => {
        try {
            let addOnList = getAddOns();
            this.setState({ addOnList: addOnList });
        } catch (error) {
            console.log('getAddOnList error', error);
        }
    }

    aggregateProductWithPackage = async (packageList, productList) => {
        if (packageList && Array.isArray(packageList) && packageList.length > 0) {
            packageList.forEach((packageObj) => {
                if (productList && Array.isArray(productList) && productList.length > 0) {
                    let selectedObj = productList.filter((productObj) => {
                        return productObj.value.toLowerCase() === packageObj.productGuid.toLowerCase()
                    });

                    if (selectedObj.length > 0) {
                        Object.assign(packageObj, { 'productName': selectedObj[0].display });
                    } else {
                        Object.assign(packageObj, { 'productName': '' });
                    }
                }
            });
        }

        return packageList;
    }

    calculateLicenseCountPerProduct = async (packageList) => {
        let newPackageObj = {};
        let result = packageList.reduce(function (finalPackageList, packageObj) {
            let key = packageObj.productGuid.toLowerCase();

            if (!newPackageObj[key]) {
                newPackageObj[key] = Object.assign({}, packageObj);
                newPackageObj[key].licenseCount = +packageObj.licenseCount;
                finalPackageList.push(newPackageObj[key]);
            } else {
                newPackageObj[key].licenseCount += +packageObj.licenseCount;
            }

            return finalPackageList;
        }, []);

        return result;
    }

    getLocation = async () => {
        try {
            // let { tenantPackageList } = this.state;
            let response = await getLocation();
            let locationList = response.data.getBranch;
            // locationList = await this.calculateProductCountPerLocation(locationList, tenantPackageList);
            this.setState({ locationList: locationList });

        } catch (error) {
            console.log('getLocation error', error);
        }
    }

    calculateProductCountPerLocation = async (locationList, packageList) => {
        console.log(locationList, packageList)
        if (locationList && Array.isArray(locationList) && locationList.length > 0) {
            locationList.forEach((locationObj) => {
                // if (packageList && Array.isArray(packageList) && packageList.length > 0) {
                let selectedItem = packageList.filter((packageObj) => {
                    return packageObj.locationGuid.toLowerCase() === locationObj.GroupGuid.toLowerCase()
                });

                if (selectedItem.length > 0) {
                    Object.assign(locationObj, { 'productCount': selectedItem.length });
                } else {
                    Object.assign(locationObj, { 'productCount': selectedItem.length });
                }
                // }
            });
        }

        return locationList;
    }

    render() {
        let { t } = this.props;
        let { tenantProductAndLicenseDetailsList, locationList, tenantLanguageList, addOnList, tenantPackageList } = this.state;
        this.calculateProductCountPerLocation(locationList, tenantPackageList);

        return (

            <main className="Dash-board">
                <div className="Dash-board-div">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <SideBar {...this.props} />
                            </div>
                            <div className="col-md-9">
                                <Header {...this.props} />
                                <div className="content-sec">
                                    {
                                        tenantLanguageList ? (
                                            <Fragment>
                                                <div className="Purchases-sec">
                                                    <div className="active-content">
                                                        <div className="">
                                                            {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
                                                            Curabitur auctor massa lobortis, vehicula eros vel, commodo quam in
                                                            <b> Active Plan</b> */}
                                                        </div>
                                                        <div className="div-post">
                                                            <h3 className="Sub-head">{t('LANGUAGE')} <span>{tenantLanguageList.length}</span></h3>
                                                        </div>
                                                        <div className="items-language">
                                                            {/* <div className="boxed">
                                                                <img className="tick" src={done_black} alt="" />
                                                                <h4 className="language">English</h4>
                                                            </div> */}

                                                            {tenantLanguageList.map((elmt, i) => {
                                                                return (
                                                                    <div className="boxed" key={i}>
                                                                        <img className="tick" src={done_black} alt="" />
                                                                        <h4 className="language">{elmt.display}</h4>
                                                                    </div>)
                                                            })}
                                                        </div>
                                                        <div className="translation">{t('Additional Translations')} : <img className="done"
                                                            src={done_black} alt="" /><b>1
                                                                Unit</b></div>
                                                        <div className="div-post">
                                                            <h3 className="Sub-head">{t('LOCATION')} <span>{locationList.length}</span></h3>
                                                        </div>


                                                        <div className="items-location">
                                                            {locationList.map((elmt, i) => {
                                                                return (
                                                                    <div className="boxed1" key={i}>
                                                                        <div className="small-box">
                                                                            <img src={done_black} alt="" className="tick" />
                                                                            <h4 className="language">{elmt.OfficeName}-{elmt.OfficeShortName}</h4>
                                                                        </div>
                                                                        <h6>{elmt.productCount} {t('Products')}</h6>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>


                                                        <div className="div-post">
                                                            <h3 className="Sub-head">{t('PRODUCT')} <span>{tenantProductAndLicenseDetailsList.length}</span></h3>
                                                        </div>

                                                        <div className="items-location">
                                                            {tenantProductAndLicenseDetailsList.map((elmt, i) => {
                                                                return (
                                                                    <div className="boxed1" key={i}>
                                                                        <div className="small-box" >
                                                                            <img src={done_black} alt="" className="tick" />
                                                                            <h4 className="language">{t(`${elmt.productName}`)}</h4>
                                                                        </div>
                                                                        <h6>{elmt.licenseCount}{t('Licenses')}</h6>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>

                                                        <div className="div-post">
                                                            <h3 className="Sub-head">{t('ADD-ON')} <span>{addOnList.length}</span></h3>
                                                        </div>

                                                        <div className="items-location">
                                                            {addOnList.map((elmt, i) => {
                                                                return (
                                                                    <div className="boxed1" key={i}>
                                                                        <div className="small-box" >
                                                                            <img src={done_black} alt="" className="tick" />
                                                                            <h4 className="addon">{t(`${elmt.display}`)}</h4>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="bottom-button purchase-bottom-btn">
                                                    <button type="button" className="btn btn-secondary" onClick={() => { this.props.history.push('/Subscription_Upgrade') }}>{t('BACK')}</button>
                                                    <button type="button" className="btn btn-primary" onClick={() => { this.props.history.push('/Bill') }} >{t('GET PRICING QUOTE')}</button>
                                                </div>
                                            </Fragment>
                                        ) : (
                                            <img src={loader} alt="" className="loader" />
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>
        )
    }
}
export default withTranslation()(Purchases)